import { c as _c } from "react/compiler-runtime";
import { LoadErrorAlert } from "@components/teams/add-to-team/load-error-alert";
import { TEAMS_DISPLAY_NAME } from "@src/constants/team-constants";
/** Tells that the teams the members are in already could not be loaded */
export function MemberTeamsLoadError(t0) {
  const $ = _c(3);
  const {
    numberOfMembers,
    onRetry
  } = t0;
  const t1 = `Couldn't check which ${TEAMS_DISPLAY_NAME} ${numberOfMembers === 1 ? "the member is" : "these members are"} in already.`;
  let t2;
  if ($[0] !== onRetry || $[1] !== t1) {
    t2 = <LoadErrorAlert title={t1} onRetry={onRetry} />;
    $[0] = onRetry;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}